import { PayloadAction, createSlice } from "@reduxjs/toolkit";

interface permissionSliceType {
  permission: any[];
}

const initialState: permissionSliceType = {
  permission: [],
};

const PermissionSlice = createSlice({
  name: "permission",
  initialState,
  reducers: {
    setPermission: (state, action: PayloadAction<any>) => {
      state.permission = action.payload;
    },
  },
});

export const { setPermission } = PermissionSlice.actions;
export default PermissionSlice.reducer;
